'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLockCombination = function IoLockCombination(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 13.8c3 2.8 5 6.7 5 11.2 0 8.3-6.7 15-15 15s-15-6.7-15-15c0-4.5 2-8.4 5-11.2v-3.8c0-5.5 4.5-10 10-10s10 4.5 10 10v3.8z m-17.5-3.8v2c2.2-1.2 4.8-2 7.5-2s5.3 0.8 7.5 2v-2c0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5z m7.5 27.5c6.9 0 12.5-5.6 12.5-12.5s-5.6-12.5-12.5-12.5-12.5 5.6-12.5 12.5 5.6 12.5 12.5 12.5z m0-23.7c6.3 0 11.3 5 11.3 11.2s-5 11.3-11.3 11.3-11.2-5-11.2-11.3 5-11.2 11.2-11.2z m9.6 13.8c0.2-0.7 0.3-1.4 0.3-2.3h-0.5v-0.5h0.6c0-0.9-0.2-1.6-0.4-2.4l-1.9 0.6-0.4-1 2-0.6c-0.3-0.8-0.6-1.4-1.1-2l-0.9 0.6-0.3-0.5 0.9-0.6c-0.5-0.6-1-1.2-1.7-1.7l-1.1 1.6-0.9-0.6 1.2-1.6c-0.6-0.4-1.3-0.8-2.1-1.1l-0.3 1.1-0.5-0.2 0.4-1c-0.7-0.2-1.6-0.4-2.3-0.4v1.5h-1.2v-1.5c-0.9 0.1-1.5 0.2-2.3 0.4l0.3 0.9-0.5 0.2-0.3-1c-0.7 0.3-1.4 0.7-2.1 1.1l1.2 1.6-0.8 0.6-1.2-1.6c-0.6 0.5-1.2 1.1-1.7 1.7l0.9 0.6-0.3 0.4-0.8-0.6c-0.5 0.6-0.8 1.3-1.1 2.1l1.9 0.6-0.4 1-2-0.6c-0.2 0.8-0.2 1.5-0.2 2.4h0.5v0.5h-0.4c0 0.9 0.1 1.6 0.3 2.3l1.9-0.6 0.3 1-1.9 0.6c0.3 0.8 0.6 1.5 1.1 2.1l0.7-0.5 0.3 0.3-0.7 0.6c0.5 0.6 1 1.2 1.6 1.7l1.2-1.6 0.8 0.6-1.2 1.6c0.7 0.4 1.4 0.8 2.1 1.1l0.3-0.9 0.5 0.2-0.3 0.8c0.8 0.2 1.4 0.3 2.3 0.4v-1.5h1.2v1.5c0.7-0.1 1.5-0.2 2.3-0.4l-0.4-0.9 0.5-0.2 0.3 1c0.8-0.3 1.5-0.7 2.1-1.1l-1.2-1.6 0.9-0.6 1.1 1.6c0.7-0.5 1.2-1.1 1.7-1.7l-0.9-0.6 0.3-0.4 0.8 0.6c0.5-0.6 0.9-1.3 1.2-2.1l-2-0.6 0.4-1z m-15.9-2.6c0-4.2 2.1-6.3 6.3-6.3s6.3 2.1 6.3 6.3-2.1 6.3-6.3 6.3-6.3-2.1-6.3-6.3z' })
        )
    );
};

exports.default = IoLockCombination;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/lock-combination.js
// module id = 2340
// module chunks = 0